import { Card, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Strings } from '@app/constants';
import { useRequestState } from '@app/hooks';
import { selectBoardDetailsState } from '@app/modules/task-board/selector';
import { FormProvider } from '@app/components';
import { ChatMessage } from './chat-section';
import { IComment } from '../type';

interface Props {
  comments: IComment[];
}
const CommentSectionCard = ({ comments }: Props) => {
  const methods = useForm();
  const [editingCommentId, setEditingCommentId] = useState<number | null>(null);

  const { data: boardData } = useRequestState({
    stateSelector: selectBoardDetailsState,
    errorShown: true,
  });

  if (!comments || comments.length === 0) return null;

  return (
    <Stack sx={{ flexDirection: 'row' }} m={1} gap={2}>
      <Card sx={{ width: '100%', pb: 2 }}>
        <Typography variant="subtitle1" p={2}>
          {Strings.taskBoard.comment}
        </Typography>
        <FormProvider methods={methods}>
          <Stack sx={{ mx: { xs: 1, md: 3 } }} mb={2}>
            {comments?.map((message, index) => (
              <ChatMessage
                key={index}
                boardData={boardData}
                editingCommentId={editingCommentId}
                setEditingCommentId={setEditingCommentId}
                methods={methods}
                message={message}
              />
            ))}
          </Stack>
        </FormProvider>
      </Card>
    </Stack>
  );
};
export { CommentSectionCard };
